/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";


import DefaultMessageComponent from "@Components/UI/Communicates/Messages/Default";


import FormFieldsGroupComponent from "@Components/UI/Forms/Group";
import FormFieldsGroupHeaderComponent from "@Components/UI/Forms/Group/Header";
import FormFieldsGroupFieldsComponent from "@Components/UI/Forms/Group/Fields";
import FormFieldComponent from "@Components/UI/Forms/Field";
import DefaultFormButton from "@Components/UI/Forms/Buttons/Default";


import {REGISTER_FORM_STEP_TYPE, RegisterFormErrorsInterface} from "@UIPages/NotAuthenticated/Register";


type RegisterFormStep2Props = {
    forwardRef?: React.ForwardedRef<any> | null;
    registerFormStep: REGISTER_FORM_STEP_TYPE, registerFormStepHandler(step: number, final?: boolean): void;
    registerFormErrors: RegisterFormErrorsInterface,
    formUserPassword: string; formUserPasswordHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    formUserPasswordRepeat: string; formUserPasswordRepeatHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    formUserPIN: string, formUserPINHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    formUserPhoneNumber: string, formUserPhoneNumberHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    formUserGeneratedID: string, formUserGeneratedLogin: string, formUserGeneratedPasswordRequirements: [],
};


export const RegisterFormStep2Component: React.FC<RegisterFormStep2Props> = ({
    forwardRef = null,
    registerFormStep, registerFormStepHandler, registerFormErrors,
    formUserPassword, formUserPasswordHandler,
    formUserPasswordRepeat, formUserPasswordRepeatHandler,
    formUserPIN, formUserPINHandler,
    formUserPhoneNumber, formUserPhoneNumberHandler,
    formUserGeneratedID, formUserGeneratedLogin, formUserGeneratedPasswordRequirements
}): JSX.Element | null => {


    const REST_API_REQUEST_STATUS= useTypedSelector(
        (state):ReturnType<any> => state.interface
    )?.apiRequestStatus;


    if (!formUserGeneratedID) return null;


    return (
        <FormFieldsGroupComponent forwardRef={forwardRef} cssClasses={registerFormStep !== 2 ? "disabled" : ""}>

            <FormFieldsGroupHeaderComponent
                headerText={`Użytkownik: ${formUserGeneratedLogin}`}
                headerLabel={`Twoja nazwa użytkownika została wygenerowana`}
                cssClasses={`special-header register-form-step2-header`}
            >
                <strong>{`Zapamiętaj ją - będzie służyła do logowania się do systemu`}</strong>
            </FormFieldsGroupHeaderComponent>

            <FormFieldsGroupFieldsComponent>

                <FormFieldComponent
                    lg={6}
                    fieldValue={formUserPassword}
                    fieldValueHandler={e => formUserPasswordHandler(e)}
                    fieldType={"password"} fieldLabel={`Hasło`} fieldControlID={`register-form-user-password`}
                    fieldDisabledStatus={registerFormStep !== 2 || !!REST_API_REQUEST_STATUS}
                    fieldError={registerFormErrors?.formUserPassword}
                    fieldLegend={`Hasło powinno składać się z minimum 8 znaków, oraz zawierać cyfrę, wielką literę i znak specjalny`}
                />

                <FormFieldComponent
                    lg={6}
                    fieldValue={formUserPasswordRepeat}
                    fieldValueHandler={e => formUserPasswordRepeatHandler(e)}
                    fieldType={"password"} fieldLabel={`Powtórz Hasło`} fieldControlID={`register-form-user-password-repeat`}
                    fieldDisabledStatus={registerFormStep !== 2 || !!REST_API_REQUEST_STATUS}
                    fieldError={registerFormErrors?.formUserPasswordRepeat}
                />

                <FormFieldComponent
                    lg={6}
                    fieldValue={formUserPIN}
                    fieldValueHandler={e => formUserPINHandler(e)}
                    fieldType={`password`} fieldLabel={`Pin do karty kierowcy`} fieldControlID={`register-form-user-pin`}
                    fieldDisabledStatus={registerFormStep !== 2 || !!REST_API_REQUEST_STATUS}
                    fieldError={registerFormErrors?.formUserPIN}
                    fieldLegend={`Aktualny PIN, używany przez Ciebie w kiosku MM`}
                />

                <FormFieldComponent
                    lg={6}
                    fieldValue={formUserPhoneNumber}
                    fieldValueHandler={e => formUserPhoneNumberHandler(e)}
                    fieldType={`number`} fieldLabel={`Nr Telefonu`} fieldControlID={`register-form-user-phone-number`}
                    fieldDisabledStatus={registerFormStep !== 2 || !!REST_API_REQUEST_STATUS}
                    fieldError={registerFormErrors?.formUserPhoneNumber}
                    fieldLegend={`Aktualny nr Telefonu, zarejestrowany w CDOK`}
                />

                <>
                    {registerFormStep === 2 && !registerFormErrors?.registrationProcess &&
	                <DefaultMessageComponent messageText={`Na numer telefonu zostanie wysłany kod weryfikacyjny`}/>
                    }
                </>

            </FormFieldsGroupFieldsComponent>

            <>
                {registerFormStep === 2 &&
		        <DefaultFormButton
			        buttonText={`Dalej`}
			        clickHandler={() => registerFormStepHandler(3)}
			        controlId={`register-form-user-step2-submit`}
			        disabled={!!REST_API_REQUEST_STATUS}
			        cssClasses={`register-form-user-step-submit`}
		        />
                }
            </>

        </FormFieldsGroupComponent>
    );

};


export default RegisterFormStep2Component;
